export enum LOCALE {
  'sv-SE' = 'sv-SE',
  'da-DK' = 'da-DK',
  'no-NO' = 'no-NO',
  'fi-FI' = 'fi-FI',  
}

export enum LANGUAGE {
  'sv' = 'sv',
  'da' = 'da',
  'no' = 'no',
  'fi' = 'fi',  
}

export enum CURRENCY {
  'DKK' = 'DKK',
  'SEK' = 'SEK',
  'NOK' = 'NOK',
  'EUR' = 'EUR',
}

export const LOCALE_CURRENCY: { [locale in LOCALE]: CURRENCY } = {
  [LOCALE['sv-SE']]: CURRENCY.SEK,
  [LOCALE['da-DK']]: CURRENCY.DKK,
  [LOCALE['no-NO']]: CURRENCY.NOK,
  [LOCALE['fi-FI']]: CURRENCY.EUR,
};

export const CURRENCY_LOCALE: { [currency in CURRENCY]: LOCALE } = {
  [CURRENCY.SEK]: LOCALE['sv-SE'],
  [CURRENCY.DKK]: LOCALE['da-DK'],
  [CURRENCY.NOK]: LOCALE['no-NO'],
  [CURRENCY.EUR]: LOCALE['fi-FI'],
};

export const DEFAULT_LANGUAGE = LANGUAGE.sv;

export const DEFAULT_LOCALE: LOCALE = LOCALE['sv-SE'];

export const DEFAULT_CURRENCY: CURRENCY = LOCALE_CURRENCY[DEFAULT_LOCALE];
